import { fork } from 'redux-saga/effects';
import { getProfileInfoWatcher } from './profile/GetProfileInfoSaga';
import { performersWatcher } from './performers/PerformersSaga';
import { signaturesWatcher } from './signatures/SignaturesSaga';
import { filtersWatcher } from './filters/FiltersSaga';
import { licenseeWatcher } from "./licensee/licenseeSaga";

export default function* SystemSettings() {
  yield fork(getProfileInfoWatcher);
  yield fork(performersWatcher);
  yield fork(signaturesWatcher);
  yield fork(filtersWatcher);
  yield fork(licenseeWatcher);
}
